import { palette } from './palette';
import { Theme } from '@mui/material';

export const typography = {
  fontFamily: [
    'Figtree',
    'Figtree'
  ].join(','),
  h1: {
    fontFamily: 'Figtree',
    fontSize: '2.5rem',
    fontWeight: '700',
    fontStyle: 'normal',
    lineHeight: '3rem'
  },
  h2: {
    fontFamily: 'Figtree',
    fontSize: '1.375rem',
    fontWeight: '700',
    lineHeight: '1rem'
  },
  h3: {
    fontFamily: 'Figtree',
    fontSize: '1.25rem',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.025rem'
  },
  h4: {
    fontFamily: 'Figtree',
    fontSize: ' 1rem',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.025rem',
    textTransform: 'none'
  },
  h5: {
    fontFamily: 'Figtree',
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: '0.0625rem'
  },
  h6: {
    fontFamily: 'Figtree',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.025rem'
  },
  body1: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.5rem',
    textTransform: 'none'
  },
  body2: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1rem'
  },
  button: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontWeight: '700',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  formLabel: {
    color: '#56626E',
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  formInput: {
    color: palette.customGray?.darker,
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1.5rem',
    textTransform: 'none'
  },
  activityHeader: {
    color: palette.secondary?.darker,
    fontFamily: 'Figtree',
    fontSize: '2rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '2rem',
    textTransform: 'none'
  },
  activitySubHeaderPrimary: {
    color: '#747D90',
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1.5rem',
    textTransform: 'none'
  },
  tableTitle: {
    color: palette.customGray?.darker,
    fontFamily: 'Figtree',
    fontSize: '1.375rem',
    fontWeight: '700',
    lineHeight: '1rem'
  },
  tableHeader: {
    color: '#747D90',
    fontFamily: 'Figtree',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '1.3125rem',
    textTransform: 'none'
  },

  tableCellLink: {
    color: palette.primary?.main,
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '1.2rem'
  },
  tableCellText: {
    color: '#747D90',
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1.5rem'
  },
  tableCellBold: {
    color: palette.customGray?.darker,
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '1.2rem'
  },
  pill: {
    fontFamily: 'Figtree',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '1.1375rem'
  },
  bodyBold: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '1.3rem'
  },
  navItemText: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1.5rem',
    color: '#56626E'
  },
  selectedNavItemText: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '1.5rem'
  },
  milestoneSectionTitle: {
    color: '#1E1F23',
    fontFamily: 'Figtree',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '.875rem',
    textTransform: 'none'
  },
  displayFieldLabel: {
    color: '#747D90',
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  displayFieldValue: {
    color: '#28292C',
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  contextPaneTitle: {
    color: '#28292C',
    fontFamily: 'Figtree',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '1.5rem',
    textTransform: 'none'
  },
  dropDownMenuItem: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  dropDownMenuTitle: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
    textTransform: 'none'
  },
  pageSectionTitle: {
    color: '#28292C',
    fontFamily: 'Figtree',
    fontSize: '1.375rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  pageSectionSubTitle: {
    fontFamily: 'Figtree',
    fontSize: '.1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    color: '#747D90'
  },
  loginFormTitle: {
    fontFamily: 'Figtree',
    fontSize: '2.5rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '3rem',
    textTransform: 'none',
    color: '#1E1F23'
  },
  tabSectionTextBold: {
    fontFamily: 'Figtree',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    letterSpacing: '0.0175rem',
    textTransform: 'none'
  },
  tabSectionTextLink: {
    fontFamily: 'Figtree',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    letterSpacing: '0.0175rem',
    textTransform: 'uppercase',
    color: palette.primary?.contrastText
  },
  modalTitle: {
    fontFamily: 'Figtree',
    fontSize: '1.375rem',
    fontWeight: '700',
    lineHeight: '1.375rem'
  },
  taskTitle: {
    fontFamily: 'Figtree',
    fontSize: '1.125rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  taskSubtitle: {
    fontFamily: 'Figtree',
    color: '#747D90',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  modalSubTitle: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.5rem',
    textTransform: 'none'

  },
  summaryMetricValue: {
    color: '#1E1F23',
    fontFamily: 'Figtree',
    fontSize: '1.375rem',
    fontWeight: '700',
    lineHeight: '1rem'
  },
  summaryMetricName: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: '1rem',
    fontWeight: '400',
    lineHeight: '1rem',
    color: '#747D90'
  },
  filterMenuTitle: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '1.3rem',
    textTransform: 'none'
  },
  filterMenuItem: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '1rem',
    textTransform: 'none',
    color: '#747D90'
  },
  loginFormSubTitle: {
    fontFamily: 'Figtree',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1.5rem',
    color: '#747D90',
    textTransform: 'none'
  }

} as Theme['typography'];
